// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.openedge.OpenEdgeVoidTransactionResponse */
/* istanbul ignore next */
@GandalfModel
export class OpenEdgeVoidTransactionResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	customerReceipt!: string | null;

	@GandalfProperty({ designType: String })
	errorCode!: string | null;

	@GandalfProperty({ designType: String })
	errorMessage!: string | null;

	@GandalfProperty({ designType: Number })
	paymentTransactionId!: number | null;

	@GandalfConstantDecorator(constants.OpenEdgeCommonVoidStatus)
	@GandalfProperty({ designType: constants.OpenEdgeCommonVoidStatus })
	result!: constants.OpenEdgeCommonVoidStatus | null;

	@GandalfConstantDecorator(constants.OpenEdgeCommonTransactionStatus)
	@GandalfProperty({ designType: constants.OpenEdgeCommonTransactionStatus })
	returnStatus!: constants.OpenEdgeCommonTransactionStatus | null;

	@GandalfConstantDecorator(constants.OpenEdgeCommonTransactionStatus)
	@GandalfProperty({ designType: constants.OpenEdgeCommonTransactionStatus })
	voidStatus!: constants.OpenEdgeCommonTransactionStatus | null;

}
